import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from '../../components/table/table.jsx';
import MediaQuery from 'react-responsive';
import * as FileSaver from 'file-saver';
import Loader from '../../components/loader/loader.jsx';
import { selectOperations, selectOperationsFilter } from '../../state/selectors/operations.js';
import operationsService from '../../services/operationsService.js';
import { useLocalization } from '../../hooks/useLocalization.js';

const Columns = [
    {
        header: "Operations.userName",
        name: "userName",
        dataType: "text",
        sortProperty: "UserName"
    },
    {
        header: "Operations.car",
        name: "car",
        dataType: "text",
        sortProperty: "Car"
    },
    {
        header: "Operations.startOperationTs",
        name: "startOperationTs",
        dataType: "datetime",
        sortProperty: "StartOperationTs"
    },
    {
        header: "Operations.endOperationTs",
        name: "operationTs",
        dataType: "datetime",
        sortProperty: "OperationTs"
    },
    {
        header: "Operations.volume",
        name: "volume",
        dataType: "float",
        sortProperty: "Volume"
    },
    {
        header: "Tanks.fuelType",
        name: "fuelType",
        dataType: "text",
        sortProperty: "FuelType"
    },
    {
        header: "Operations.tankBalance",
        name: "tankBalance",
        dataType: "float",
        sortProperty: "TankBalance"
    }
];

const MobileColumns = [
    {
        header: "Operations.userName",
        name: "userName",
        dataType: "text",
        sortProperty: "UserName"
    },
    {
        header: "Operations.car",
        name: "car",
        dataType: "text",
        sortProperty: "Car"
    },
    {
        header: "Operations.endOperationTs",
        name: "operationTs",
        dataType: "datetime",
        sortProperty: "OperationTs"
    },
    {
        header: "Operations.volume",
        name: "volume",
        dataType: "float",
        sortProperty: "Volume"
    },
    {
        header: "Tanks.fuelType",
        name: "fuelType",
        dataType: "text",
        sortProperty: "FuelType"
    },
    {
        header: "Operations.tankBalance",
        name: "tankBalance",
        dataType: "text",
        sortProperty: "TankBalance"
    }
];

const OperationsList = () => {
    const operations = useSelector(selectOperations());
    const filter= useSelector(selectOperationsFilter());
    const [loading, setLoading] = useState(false);
    const { i18n } = useLocalization();
    
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        const timer = setInterval(async() => {await getData(filter)}, 5000);

        return () => {
            token.cancel();
            clearInterval(timer);
        }
    }, [filter])

    const token = {cancel: () => {}};

    const getData = async (filt) => {
        token.cancel();
        filt = filt ? filt : filter;
        setLoading(true);
        await operationsService.getOperations(filt, token).then(setLoading(false));
    }

    const getReport = async () => {
        setLoading(true);
        const data = await operationsService.getReport(filter);
        setLoading(false);
        if (data) {
            FileSaver.saveAs(data, 'operations.xlsx');
        }
    }

    let modelFilter = {
        userName: {
            name: "userName",
            type: "string",
            header: i18n.t('Operations.Filter.userName'),
            value: filter.modelFilter.userName
        },
        car: {
            name: "car",
            type: "string",
            header: i18n.t('Operations.Filter.car'),
            value: filter.modelFilter.car
        },
        fuelType: {
            name: "fuelType",
            type: "string",
            header: i18n.t('Operations.Filter.fuelType'),
            value: filter.modelFilter.tankName
        },
        dateTime: {
            name: "dateTime",
            type: "dates",
            dateFrom: {
                name: "dateFrom",
                header: i18n.t("Operations.Filter.dateFrom"),
                value: filter.modelFilter.dateFrom
            },
            dateTo: {
                name: "dateTo",
                header: i18n.t("Operations.Filter.dateTo"),
                value: filter.modelFilter.dateTo
            }
        }
    };

    return (
        <div>
            <MediaQuery minDeviceWidth={1224}>
                <Table settings={{
                    columns: Columns,
                    items: operations,
                    itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: getData,
                    getReportFunction: getReport
                }} />
                {loading && <Loader />}
            </MediaQuery>
            <MediaQuery maxDeviceWidth={1224}>
                <Table settings={{
                    columns: MobileColumns,
                    items: operations,
                    itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: getData,
                    getReportFunction: getReport
                }} />

            </MediaQuery>
        </div>
    );

}

export default OperationsList;